var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _circle, _circle2, _path3, _circle3, _circle4, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 109,
    viewBox: "0 0 224 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 71.5,
    width: 167,
    height: 12,
    rx: 6,
    fill: "#E2F7E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 21,
    width: 59,
    height: 12,
    rx: 6,
    fill: "#E2F7E7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 48,
    width: 149,
    height: 12,
    rx: 6,
    fill: "#E2F7E7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 1,
    width: 45,
    height: 12,
    rx: 6,
    fill: "#E2F7E7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 198.5,
    y: 5,
    width: 17,
    height: 12,
    rx: 6,
    fill: "#E2F7E7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 206.5,
    y: 54,
    width: 17,
    height: 12,
    rx: 6,
    fill: "#E2F7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 60H153.5C146.861 61.2449 146.861 70.7551 153.5 72H65.5C71.9611 70.8462 72.2736 61.6934 65.9063 60.1016L65.5 60Z",
    fill: "#E2F7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.5 13H178.5C175.425 14.7802 175.425 19.2198 178.5 21H159.5C162.355 19.4256 162.662 15.4407 160.081 13.4483L159.5 13Z",
    fill: "#E2F7E7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 7,
    r: 6.5,
    stroke: "#54CB69"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 153.5,
    cy: 103,
    r: 5.5,
    stroke: "#54CB69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.85 42.65V46H206.65V42.65H210V40.85H206.65V37.5H204.85V40.85H201.5V42.65H204.85Z",
    fill: "#54CB69"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 55.5,
    r: 44,
    fill: "#E2F7E7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 55.5,
    r: 34,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 52.2114V55.0174C142.496 61.5945 140.367 67.9942 136.428 73.262C132.49 78.5298 126.955 82.3835 120.648 84.2483C114.341 86.1132 107.6 85.8892 101.43 83.6099C95.2606 81.3306 89.9932 77.118 86.4134 71.6005C82.8337 66.0829 81.1334 59.556 81.5661 52.9932C81.9989 46.4304 84.5415 40.1832 88.8148 35.1835C93.088 30.1838 98.863 26.6994 105.278 25.2499C111.694 23.8004 118.406 24.4636 124.414 27.1405",
    stroke: "#54CB69",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.5 41.5L110.5 61.52L104.5 55.52",
    stroke: "#54CB69",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.1e929014332a6c40bf147a9cf3c95f99.svg";
export { ForwardRef as ReactComponent };